import React from 'react'

const CansCocktailsTemplate = (props) => {
    console.log(props)
    const canBeer = props.cansMenu
    const cocktails = props.cocktailsMenu
    const mocktails = props.mocktailsMenu

    const getPrice = (number) => {
        let price = parseFloat(number)
        return price
    }

    return (
        <div>
            <div className="cans-cocktails-page">
                <div className="background-image">
                    <div className="col-left">
                        <div className="column pl1-taps-cans-pg-left ">
                            <div className="pl1-cans-new">
                            {canBeer ? 
                                <>
                                     {canBeer.map(item => (
                                        <div className="pl-can-item-page tap-item-print">
                                            {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                            <div className="print-item-line-two pl1">{item.containers[0].name} • <span className="style-print-can pl1"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                                        </div>
                                    ))}
                                </>
                                :
                                <>loading...</>
                            }
                            </div>
                        </div>
                    </div>
                    <div className="col-right">
                        <div className="column pl1-cans-cocktails-pg-right">
                            <div className="cocktail-container cocktail-mocktail-container-new">
                                {cocktails
                                    ?
                                    <div>
                                        <div className="cocktail-section">
                                            <div className="cocktail-section-title">
                                                Cocktails
                                            </div>
                                            {cocktails.map(cocktail =>(
                                                <div className="cocktail-item cocktail-item-new">
                                                    <div className="cocktail-item-title">{cocktail.name} • <span className="cocktail-price">{getPrice(cocktail.containers[0].price)}</span></div>
                                                    <div className="cocktail-item-description">{cocktail.description}</div>
                                                </div>
                                            ))}

                                        </div>
                                        <div className="mocktail-section">
                                        <div className="cocktail-section-title mocktail-section-new">
                                                Mocktails
                                            </div>
                                            {mocktails.map(mocktail =>(
                                                <div className="cocktail-item cocktail-item-new">
                                                    <div className="cocktail-item-title">{mocktail.name} • <span className="cocktail-price">{getPrice(mocktail.containers[0].price)}</span></div>
                                                    <div className="cocktail-item-description">{mocktail.description}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    :
                                    <div>loading...</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
} 
export default CansCocktailsTemplate